// extracted by mini-css-extract-plugin
export default {"bodySup":"Superscript_bodySup__0qEbo"};